module.exports = __webpack_public_path__ + "static/sterling_737x621-586ecd13d82c881350c421ff7dcca9b7.webp";